import { useRef } from "react"
import { Button, ButtonProps } from "@mui/material"

interface RepeatButtonProps extends ButtonProps {
    onClick: () => void
    delay?: number
}

export const RepeatButton = ({
    onClick,
    delay = 200,
    children,
    ...rest
}: RepeatButtonProps) => {
    const intervalRef = useRef<NodeJS.Timeout | null>(null)

    const handleMouseDown = () => {

        onClick()
        intervalRef.current = setInterval(() => {

            onClick();
        }, delay)
    }

    const handleMouseUp = () => {

        if (intervalRef.current) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
        }
    }

    const handleMouseLeave = () => {

        if (intervalRef.current) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
        }
    }

    return (
        <Button
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
            {...rest}
        >
            {children}
        </Button>
    )
}

